// extracted by mini-css-extract-plugin
export default {"container":"Products_container__GEfQ7","products":"Products_products__0CI37","menu":"Products_menu__OnTXm","list":"Products_list__Bn-Ae","product":"Products_product__QElQK"};